/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
import React, { useState, useEffect, useRef, Suspense, useMemo } from "react";
import "../../app/custom.scss";
import { useDispatch, useSelector } from "react-redux";
import { setIsDeepDiveDashboard } from "../../redux/actions/dashboard/Tab1";
import isEqual from "react-fast-compare";
import {
  setDeletePostFlag,
  setMarkInfluencersFlag,
  setScreenIsDeepDive,
  setScreenIsDeepDiveDashboard,
} from "../../redux/actions/commandCenter/screens/screen";
import aiStars from "../../assets/WidgetMaker/ai_stars-icon.svg";
import { Tooltip } from "antd";

import ErrorBoundary from "../../ErrorBoundary";
import {
  getPaneIndex,
  getWindowLocationPath,
  kFormatter,
  useQuery,
} from "../../redux/constants";
import { SecondstoHumanReadable } from "../../components/utils/charts/HighCharts/graphFunction";
import {
  getShareTemplateData,
  setFetchSectionData,
  setFetchTemplateData,
} from "../../redux/actions/ApiCall/apiCall";
import "./DeepDiveDashboard.scss";
import InfoHeader from "./components/InfoHeader";
import {
  resetDeepDiveDashboard,
  setDeepDiveSelectedSectionIndex,
  setSectionsInDashboardTemplateData,
} from "../../redux/actions/DeepDiveDashboard/DeepDiveDashboard";
import NoGraphData from "../../components/workspace/DisplayChart/NoGraphData";
import SectionTabs from "./components/SectionTabs";
import { setOptionHighChart } from "../../redux/actions/HighChart";
import SectionWidgetContainer from "./components/SectionWidgetContainer";
const DeepDiveDashboard = () => {
  const divRef = useRef();
  const infoRef = useRef();
  const dispatch = useDispatch();
  const query = useQuery();
  const [visible, setVisible] = useState(true);
  const [dashboardInitializedStatus, setDashboardInitializedStatus] =
    useState(false);

  const [sections, setSections] = useState(null);

  const authParams = useSelector((state) => state?.Authentication?.authParams);

  const panes = useSelector((state) => state?.Tab1?.panes);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const temporary_words = useSelector(
    (state) => state?.attributes?.temporary_words
  );

  const All_Share_attributes = useSelector(
    (state) => state?.WidgetMaker?.All_Share_attributes
  );

  const shareTemplateData = useSelector(
    (state) => state?.ApiCall?.shareTemplateData
  );
  const shareSelectedDeepdiveWidget = useSelector(
    (state) => state?.Share?.share_selected_deepdive_widget
  );
  const shareBrands = useSelector((state) => state?.ApiCall?.shareBrands);
  const shareCategory = useSelector((state) => state?.ApiCall?.shareCategory);
  const graphConditionConfigData = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const screen = useSelector((state) => state?.Screens?.screen);
  const brands = useSelector(
    (state) => state?.ApiCall?.brands?.data?.result?.brands
  );
  const brandlogicalgroup = useSelector(
    (state) => state?.ApiCall?.brandlogicalgroup?.data?.result
  );
  const competitorBrands = useSelector(
    (state) => state?.WidgetAPI?.competitorBrands?.data?.result
  );
  const isWidgetEdit = useSelector((state) => state?.Filter?.isWidgetEdit);
  const screenSettingFlag = useSelector(
    (state) => state?.Screens?.screen_setting_flag
  );

  const deepdiveDashboardLoader = useSelector(
    (state) => state?.DeepDiveDashboard?.dashboardLoader
  );
  const deepdiveDashboardData = useSelector(
    (state) => state?.DeepDiveDashboard?.dashboardData
  );
  const deepdiveDashboardTemplateData = useSelector(
    (state) => state?.DeepDiveDashboard?.dashboardTemplateData
  );
  const deepdiveSectionFetchLoader = useSelector(
    (state) => state?.DeepDiveDashboard?.sectionFetchLoader
  );
  const activeDashboardIndex = useSelector(
    (state) => state?.DeepDiveDashboard?.activeDashboardIndex
  );
  const openedDashboardList = useSelector(
    (state) => state?.DeepDiveDashboard?.openedDashboardList
  );
  const selectedSectionIndex = useSelector(
    (state) => state?.DeepDiveDashboard?.selectedSectionIndex
  );
  let index = getPaneIndex(panes, activeKey);

  const handleCancel = () => {
    let pathName = getWindowLocationPath()?.toLowerCase();
    window.stop();
    if (activeDashboardIndex - 1 === 0) {
      // To close Deep Dive Modal
      if (pathName === "CommandCenter"?.toLowerCase()) {
        dispatch(setMarkInfluencersFlag(false));
        dispatch(setDeletePostFlag(false));

        // To close Deep Dive Modal
        dispatch(setScreenIsDeepDiveDashboard(false));
      } else if (shareBrands) {
        // For Share Dashboard, we need to set the deep dive object
        shareTemplateData &&
          dispatch({
            type: "SET_SHARE_TEMPLATE_DATA",
            payload: {
              ...shareTemplateData,
              isDeepDiveDashboard: false,
            },
          });
      } else {
        let index = getPaneIndex(panes, activeKey);
        dispatch(setIsDeepDiveDashboard(false, index));
      }
    }

    //to clear opdata
    dispatch(setOptionHighChart(null));
    dispatch(resetDeepDiveDashboard(true));
    document.body.style = "";
  };

  const controlNavbar = () => {
    if (divRef?.current?.clientWidth > 769) {
      if (divRef?.current?.clientHeight > 600) {
        if (window.scrollY > infoRef?.current?.clientHeight) {
          setVisible(false);
        } else if (window.scrollY < infoRef?.current?.clientHeight - 80) {
          setVisible(true);
        }
      } else if (divRef?.current?.clientHeight < 540) {
        if (window.scrollY === 0) {
          setVisible(true);
        }
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", controlNavbar);
    return () => {
      window.removeEventListener("scroll", controlNavbar);
    };
  }, []);

  // To reset the status
  useEffect(() => {
    // To reset the status, so that it can be set again when the dashboard is initialized and template data is fetched
    if (activeDashboardIndex >= 0 && dashboardInitializedStatus)
      setDashboardInitializedStatus(false);
  }, [activeDashboardIndex, openedDashboardList]);

  useEffect(() => {
    let templateId = deepdiveDashboardData?.template_id || null;
    if (
      (authParams || shareBrands) &&
      templateId &&
      !deepdiveDashboardLoader &&
      !deepdiveDashboardTemplateData &&
      !dashboardInitializedStatus
    ) {
      setDashboardInitializedStatus(true);
      if (!shareBrands) {
        let stateContainer = {
          brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
          firstSection: true,
          singleBrands: brands,
          // global_dashboard_duration: global_dashboard_duration,
          // global_dashboard_brands: [
          //   "000-000-001",
          //   "000-000-002",
          //   "000-000-003",
          //   "000-000-004",
          // ].includes(id)
          //   ? global_dashboard_single_brands
          //   : global_dashboard_brands,
          competitorBrands: competitorBrands,
          graphConditionConfig: graphConditionConfigData,
          temporary_words: temporary_words,
          is_modified_date: null,
          isDeepDiveDashboard: true,
        };
        let templateObject = {
          template_id: templateId,
          created_date: null,
          call_source: "DIY", // new call_source will add later
        };
        dispatch(
          setFetchTemplateData(
            authParams,
            templateId,
            stateContainer,
            templateObject
          )
        );
      } else {
        const password = sessionStorage?.getItem("shareLinkPassword");
        const share_id = query?.get("share_id");
        let templateObject = {
          template_id: templateId,
          created_date: null,
          call_source: "DIY", // new call_source will add later
        };
        let shareObj = {
          shareBrands: shareBrands,
          shareCategory: shareCategory,
          graphConditionConfig: graphConditionConfigData,
          isDeepDiveDashboard: true,
          templateObject: templateObject,
        };
        if (share_id)
          dispatch(getShareTemplateData(share_id, shareObj, password));
      }
    }
  }, [
    authParams,
    deepdiveDashboardLoader,
    deepdiveDashboardData,
    shareBrands,
    shareCategory,
    dashboardInitializedStatus,
  ]);
  useEffect(() => {
    if (dashboardInitializedStatus && deepdiveDashboardTemplateData) {
      // calculate sections data to be shown in deepdive dashboard
      if (deepdiveDashboardTemplateData?.sections?.length > 0) {
        let sections = deepdiveDashboardTemplateData?.sections?.map(
          (section) => {
            return {
              ...section,
            };
          }
        );
        setSections(sections);
        dispatch(setDeepDiveSelectedSectionIndex(selectedSectionIndex || 0));
        // console.log("sections ===>", sections);
      } else if (
        // This condition is to handle the case when there are no sections in the template data
        // once we set default section in the template data, this condition will not be executed
        deepdiveDashboardTemplateData?.section_id
      ) {
        // If no sections are present, we can set a default section or handle it accordingly
        let section = [
          {
            section_id: deepdiveDashboardTemplateData?.section_id,
            widgets:
              deepdiveDashboardTemplateData?.widgets &&
              Array.isArray(deepdiveDashboardTemplateData?.widgets)
                ? deepdiveDashboardTemplateData?.widgets
                : null,
          },
        ];
        // console.log("Default section ===>", section);
        dispatch(setSectionsInDashboardTemplateData(section, true)); //passing true to indicate this is only widget case
      }
    }
  }, [
    deepdiveDashboardTemplateData,
    deepdiveDashboardLoader,
    activeDashboardIndex,
  ]);

  const getSectionData = (section) => {
    // if section data/widget are not loaded then perform section fetch
    if (
      !section?.widgets &&
      authParams &&
      !shareBrands &&
      !deepdiveDashboardLoader &&
      !deepdiveSectionFetchLoader
    ) {
      let params = {
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        singleBrands: brands,
        competitorBrands: competitorBrands,
        graphConditionConfig: graphConditionConfigData,
        deepdiveDashboardData: deepdiveDashboardData,
        isDeepDiveDashboard: true,
      };
      let templateId = deepdiveDashboardData?.template_id || null;
      dispatch(
        setFetchSectionData(authParams, section?.section_id, params, templateId)
      );
    }
  };
  const selectedSection = useMemo(() => {
    if (
      sections &&
      Array.isArray(sections) &&
      sections?.length > 0 &&
      selectedSectionIndex >= 0
    ) {
      return sections[selectedSectionIndex]
        ? { ...sections[selectedSectionIndex] }
        : null;
    }
    return null;
  }, [
    sections,
    selectedSectionIndex,
    deepdiveSectionFetchLoader,
    deepdiveDashboardLoader,
  ]);
  useEffect(() => {
    // if section data/widget are not loaded then perform section fetch
    if (
      selectedSection &&
      !selectedSection?.widgets &&
      !deepdiveSectionFetchLoader &&
      !deepdiveDashboardLoader
    ) {
      getSectionData(selectedSection);
    }
  }, [selectedSection]);

  // Handler for tab click
  const handleSectionChange = (section, sectionIndex) => {
    dispatch(setDeepDiveSelectedSectionIndex(sectionIndex));
    //to clear opdata
    dispatch(setOptionHighChart(null));
    // to scroll on top
    window.scrollTo(0, 0);
  };
  // to set local state on initialized if data already present
  useEffect(() => {
    if (deepdiveDashboardTemplateData) {
      setDashboardInitializedStatus(true);
      if (deepdiveDashboardTemplateData?.sections?.length > 0) {
        let sections = deepdiveDashboardTemplateData?.sections?.map(
          (section) => {
            return {
              ...section,
            };
          }
        );
        setSections(sections);
        dispatch(setDeepDiveSelectedSectionIndex(selectedSectionIndex || 0));
      }
    }
  }, []);
  const deepdive_object = useMemo(() => {
    if (deepdiveDashboardData) return deepdiveDashboardData;
    return null;
  }, [deepdiveDashboardData]);

  const disableTabAction = useMemo(() => {
    let deepDiveDashboardApiCalledList = global?.deepDiveDashboardApiCalledList
      ? global?.deepDiveDashboardApiCalledList
      : deepdiveDashboardTemplateData?.dashboard_called_api_list;
    if (
      deepdiveDashboardTemplateData?.dashboard_called_api_list &&
      Array.isArray(deepdiveDashboardTemplateData?.dashboard_called_api_list) &&
      deepdiveDashboardTemplateData?.dashboard_called_api_list?.length > 0
    ) {
      return true;
    }
    return false;
  }, [deepdiveDashboardTemplateData]);
  // console.log(
  //   "DeepDive Dashboard rendered ===>",
  //   deepdiveDashboardData,
  //   "deepdiveDashboardLoader : ",
  //   deepdiveDashboardLoader,
  //   "deepdiveDashboardTemplateData : ",
  //   deepdiveDashboardTemplateData,
  //   "deepdive_object : ",
  //   deepdive_object,
  //   "selectedSection : ",
  //   selectedSection,
  //   "disableTabAction : ",
  //   disableTabAction,
  //   "openedDashboardList : ",
  //   openedDashboardList,
  //   "activeDashboardIndex : ",
  //   activeDashboardIndex,
  //   "dashboardInitializedStatus : ",
  //   dashboardInitializedStatus
  // );

  return (
    <>
      <div
        className={`DeepDiveDashboard ${
          authParams?.template_id ? "DeepDiveDashboard--v3 " : " "
        } box-shadow_bottom`}
        style={shareTemplateData ? { top: "0" } : {}}
      >
        <div className="DeepDiveDashboard__Header border-bottom">
          <div
            className="d-flex cursor-pointer align-items-center"
            onClick={() => handleCancel()}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              className="mr-1 ml-0"
              style={{
                fill: "var(--locobuzz-primary-text-color, #3b5175)",
                cursor: "pointer",
              }}
            >
              <path d="M0 0h24v24H0z" fill="none" />
              <path
                d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z"
                fill="var(--locobuzz-primary-text-color)"
              />
            </svg>

            <span className={`text_regular font-weight600 deepdive__span`}>
              Back
            </span>
          </div>
          {deepdive_object?.deepdive_on?.deep_dive_id &&
          deepdive_object?.deepdive_on?.widget_inner_id ? (
            <>
              <div
                className="d-flex flex-wrap align-items-center justify-content-center"
                // style={{ width: "calc(100% - 8rem)" }}
              >
                <img
                  style={{
                    margin: "0.5rem",
                    width: "1.4rem",
                    height: "1.9rem",
                  }}
                  src={aiStars}
                />
                <span
                  className="text_regular mr-1"
                  style={{ fontWeight: "600" }}
                >
                  {deepdive_object?.deepdive_on?.name}
                </span>
              </div>
            </>
          ) : (
            <>
              {/* To display template title in template usage details */}
              <div
                className="d-flex flex-wrap align-items-center justify-content-center"
                style={{ width: "calc(100% - 8rem)" }}
              >
                {deepdive_object?.deepdive_on?.x_axis &&
                deepdive_object?.deepdive_on?.x_axis?.value ? (
                  <div className="mr-15">
                    <span className="text_regular mr-1">
                      {shareTemplateData?.is_prolific_user_deep_dive ||
                      panes?.[index]?.is_prolific_user_deep_dive
                        ? "Author Name:"
                        : "X-Attribute:"}
                    </span>
                    <span className="text_regular font-weight600 deepdive__span">
                      {deepdive_object?.deepdive_on?.x_axis?.trace_name && (
                        <>
                          {deepdive_object?.deepdive_on?.x_axis?.trace_name}{" "}
                          {shareTemplateData?.is_prolific_user_deep_dive ||
                          panes?.[index]?.is_prolific_user_deep_dive ? (
                            ""
                          ) : (
                            <>({deepdive_object?.deepdive_on?.x_axis?.value})</>
                          )}
                        </>
                      )}
                    </span>
                  </div>
                ) : (
                  ""
                )}

                {deepdive_object?.deepdive_on?.y_axis &&
                deepdive_object?.deepdive_on?.y_axis?.value ? (
                  <div className="mr-15">
                    <span className="text_regular mr-1">Y-Attribute:</span>
                    <span className="text_regular font-weight600 deepdive__span">
                      {deepdive_object?.deepdive_on?.y_axis?.trace_name && (
                        <>
                          {deepdive_object?.deepdive_on?.y_axis?.trace_name} (
                          {deepdive_object?.deepdive_on?.y_axis?.value})
                        </>
                      )}
                    </span>
                  </div>
                ) : (
                  ""
                )}

                {deepdive_object?.deepdive_on?.y_series &&
                deepdive_object?.deepdive_on?.y_series?.value >= 0 &&
                !deepdive_object?.isSurveyCardBased ? (
                  <div className="mr-15">
                    <span className="text_regular mr-1">{`${
                      deepdive_object?.deepdive_on?.y_series_secondary
                        ? "Series 1"
                        : "Y-Series"
                    }:`}</span>
                    {authParams?.screen_id && screen?.deletePostFlag ? (
                      <>
                        <Tooltip title="To see the updated number, refresh the screen.">
                          <span
                            style={{ color: "lightgrey" }}
                            className="font-weight600"
                          >
                            {deepdive_object?.deepdive_on?.y_series?.trace_name}{" "}
                            (
                            {graphConditionConfigData?.[
                              "time-label-attrs"
                            ]?.includes(
                              deepdive_object?.deepdive_on?.y_series?.attribute
                            ) ||
                            graphConditionConfigData?.[
                              "ticket-time-label-attrs"
                            ]?.includes(
                              deepdive_object?.deepdive_on?.y_series?.attribute
                            )
                              ? SecondstoHumanReadable(
                                  deepdive_object?.deepdive_on?.y_series?.value
                                )
                              : kFormatter(
                                  deepdive_object?.deepdive_on?.y_series?.value
                                )}
                            )
                          </span>
                        </Tooltip>
                      </>
                    ) : (
                      <>
                        <span className="text_regular font-weight600 deepdive__span">
                          {deepdive_object?.deepdive_on?.y_series?.trace_name} (
                          {graphConditionConfigData?.[
                            "time-label-attrs"
                          ]?.includes(
                            deepdive_object?.deepdive_on?.y_series?.attribute
                          ) ||
                          graphConditionConfigData?.[
                            "ticket-time-label-attrs"
                          ]?.includes(
                            deepdive_object?.deepdive_on?.y_series?.attribute
                          )
                            ? SecondstoHumanReadable(
                                deepdive_object?.deepdive_on?.y_series?.value
                              )
                            : kFormatter(
                                deepdive_object?.deepdive_on?.y_series?.value
                              )}
                          )
                        </span>
                      </>
                    )}
                  </div>
                ) : (
                  ""
                )}
                {deepdive_object?.deepdive_on?.y_series_secondary &&
                deepdive_object?.deepdive_on?.y_series_secondary?.value >= 0 ? (
                  <div className="mr-15">
                    <span className="text_regular mr-1">Series 2:</span>
                    <span className="text_regular font-weight600 deepdive__span">
                      {
                        deepdive_object?.deepdive_on?.y_series_secondary
                          ?.trace_name
                      }{" "}
                      (
                      {graphConditionConfigData?.["time-label-attrs"]?.includes(
                        deepdive_object?.deepdive_on?.y_series_secondary
                          ?.attribute
                      ) ||
                      graphConditionConfigData?.[
                        "ticket-time-label-attrs"
                      ]?.includes(
                        deepdive_object?.deepdive_on?.y_series_secondary
                          ?.attribute
                      )
                        ? SecondstoHumanReadable(
                            deepdive_object?.deepdive_on?.y_series_secondary
                              ?.value
                          )
                        : kFormatter(
                            deepdive_object?.deepdive_on?.y_series_secondary
                              ?.value
                          )}
                      )
                    </span>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </>
          )}
          {/* Tempraly added bacause justify-content-between is applied on parent div */}
          <div></div>
        </div>

        {(deepdive_object?.deepdive_on?.deep_dive_id &&
          deepdive_object?.deepdive_on?.widget_inner_id) ||
        deepdive_object?.account_list?.length > 0 ||
        deepdive_object?.isWorkFlowBased ||
        deepdive_object?.isTicketBased ||
        [
          "000-000-567", // for twitter screen
          "000-000-566", // for google screen
        ]?.includes(authParams?.screen_id) ? (
          <></>
        ) : (
          <>
            {/* <div
              className={`DeepDiveDashboard__infoBar animated border-bottom
                    ${visible ? "scrollVisible" : "unvisible"}
              `}
              ref={infoRef}
            >
              <ErrorBoundary>
                <InfoHeader />
              </ErrorBoundary>
            </div> */}
            {/* for now commenting out info rich text widget */}
            {sections && !deepdiveDashboardTemplateData?.onlyWidgets ? (
              <ErrorBoundary>
                <SectionTabs
                  sections={sections}
                  activeSectionId={selectedSection?.section_id}
                  onSectionChange={handleSectionChange}
                  isLoading={deepdiveDashboardLoader}
                  isDisabled={
                    deepdiveDashboardLoader ||
                    deepdiveSectionFetchLoader ||
                    disableTabAction
                  }
                />
              </ErrorBoundary>
            ) : (
              ""
            )}
          </>
        )}
      </div>
      <div
        className="DeepDiveDashboard__Container container-fluid bg__gray pt-15 pb-15 full"
        ref={divRef}
      >
        <>
          {/* Loader */}
          {deepdiveDashboardLoader || deepdiveSectionFetchLoader ? (
            <div
              className={`DeepDiveDashboard__Loader loader portlet1`}
              style={{ height: visible ? "" : "calc(100vh - 17.2rem)" }}
            >
              <div className="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          ) : selectedSection &&
            Array.isArray(selectedSection?.widgets) &&
            selectedSection?.widgets?.length ? (
            <>
              <ErrorBoundary>
                <SectionWidgetContainer
                  widgets={selectedSection?.widgets}
                  section_index={selectedSectionIndex}
                  section_id={selectedSection?.section_id}
                  sections={sections}
                />
              </ErrorBoundary>
            </>
          ) : (
            <>
              <ErrorBoundary>
                <NoGraphData
                  errorCode={"No Widgets Found"}
                  isDeepDiveDashboard={true}
                />
              </ErrorBoundary>
            </>
          )}
        </>
      </div>
    </>
  );
};
export default React.memo(DeepDiveDashboard, isEqual);
